__turbopack_context__.v({
  "appliedFilters": "applied-filters-module-scss-module__rD1Ifa__appliedFilters",
});
